import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import QICards from 'components/Indoor_Cameras/IN-8015_HD/Quick_Installation/QICards';
import NavButtons from 'components/Indoor_Cameras/IN-8015_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  QICards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};